/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../model';
// @ts-ignore
import { GetCustomerResponse } from '../model';
// @ts-ignore
import { GetUserResponse } from '../model';
// @ts-ignore
import { GetUsersResponse } from '../model';
// @ts-ignore
import { PostForgotPasswordRequest } from '../model';
// @ts-ignore
import { PostResendInvitationRequest } from '../model';
// @ts-ignore
import { PostResetPasswordRequest } from '../model';
// @ts-ignore
import { PostUserInviteRequest } from '../model';
// @ts-ignore
import { PutSpUser } from '../model';
// @ts-ignore
import { PutUserRequest } from '../model';
// @ts-ignore
import { SpUser } from '../model';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostForgotPasswordRequest} postForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (postForgotPasswordRequest: PostForgotPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postForgotPasswordRequest' is not null or undefined
            assertParamExists('forgotPassword', 'postForgotPasswordRequest', postForgotPasswordRequest)
            const localVarPath = `/api/users/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postForgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckUser: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getCheckUser', 'email', email)
            const localVarPath = `/api/users/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [searchText] 
         * @param {string} [organization] 
         * @param {string} [group] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (orderBy?: string, orderDesc?: string, page?: number, limit?: number, searchText?: string, organization?: string, group?: string, status?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostUserInviteRequest} postUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoInvite: async (postUserInviteRequest: PostUserInviteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postUserInviteRequest' is not null or undefined
            assertParamExists('postDoInvite', 'postUserInviteRequest', postUserInviteRequest)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUserInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostUserInviteRequest} postUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoInviteV2: async (postUserInviteRequest: PostUserInviteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postUserInviteRequest' is not null or undefined
            assertParamExists('postDoInviteV2', 'postUserInviteRequest', postUserInviteRequest)
            const localVarPath = `/api/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUserInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SpUser} spUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoSyncUser: async (spUser: SpUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spUser' is not null or undefined
            assertParamExists('postDoSyncUser', 'spUser', spUser)
            const localVarPath = `/api/users/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutSpUser} putSpUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoSyncUser: async (id: string, putSpUser: PutSpUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putDoSyncUser', 'id', id)
            // verify required parameter 'putSpUser' is not null or undefined
            assertParamExists('putDoSyncUser', 'putSpUser', putSpUser)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putSpUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PutUserRequest} putUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoUpdateUser: async (putUserRequest: PutUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putUserRequest' is not null or undefined
            assertParamExists('putDoUpdateUser', 'putUserRequest', putUserRequest)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostResendInvitationRequest} postResendInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation: async (postResendInvitationRequest: PostResendInvitationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postResendInvitationRequest' is not null or undefined
            assertParamExists('resendInvitation', 'postResendInvitationRequest', postResendInvitationRequest)
            const localVarPath = `/api/users/resend-invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postResendInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostResetPasswordRequest} postResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (postResetPasswordRequest: PostResetPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postResetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'postResetPasswordRequest', postResetPasswordRequest)
            const localVarPath = `/api/users/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostForgotPasswordRequest} postForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(postForgotPasswordRequest: PostForgotPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(postForgotPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckUser(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckUser(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [searchText] 
         * @param {string} [organization] 
         * @param {string} [group] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(orderBy?: string, orderDesc?: string, page?: number, limit?: number, searchText?: string, organization?: string, group?: string, status?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(orderBy, orderDesc, page, limit, searchText, organization, group, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostUserInviteRequest} postUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDoInvite(postUserInviteRequest: PostUserInviteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDoInvite(postUserInviteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostUserInviteRequest} postUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDoInviteV2(postUserInviteRequest: PostUserInviteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDoInviteV2(postUserInviteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SpUser} spUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDoSyncUser(spUser: SpUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDoSyncUser(spUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutSpUser} putSpUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDoSyncUser(id: string, putSpUser: PutSpUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDoSyncUser(id, putSpUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutUserRequest} putUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDoUpdateUser(putUserRequest: PutUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDoUpdateUser(putUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostResendInvitationRequest} postResendInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvitation(postResendInvitationRequest: PostResendInvitationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvitation(postResendInvitationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostResetPasswordRequest} postResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(postResetPasswordRequest: PostResetPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(postResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {PostForgotPasswordRequest} postForgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(postForgotPasswordRequest: PostForgotPasswordRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.forgotPassword(postForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckUser(email: string, options?: any): AxiosPromise<GetUserResponse> {
            return localVarFp.getCheckUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(options?: any): AxiosPromise<GetCustomerResponse> {
            return localVarFp.getUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [searchText] 
         * @param {string} [organization] 
         * @param {string} [group] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(orderBy?: string, orderDesc?: string, page?: number, limit?: number, searchText?: string, organization?: string, group?: string, status?: string, options?: any): AxiosPromise<GetUsersResponse> {
            return localVarFp.getUsers(orderBy, orderDesc, page, limit, searchText, organization, group, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostUserInviteRequest} postUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoInvite(postUserInviteRequest: PostUserInviteRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.postDoInvite(postUserInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostUserInviteRequest} postUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoInviteV2(postUserInviteRequest: PostUserInviteRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.postDoInviteV2(postUserInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpUser} spUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoSyncUser(spUser: SpUser, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.postDoSyncUser(spUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutSpUser} putSpUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoSyncUser(id: string, putSpUser: PutSpUser, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.putDoSyncUser(id, putSpUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PutUserRequest} putUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoUpdateUser(putUserRequest: PutUserRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.putDoUpdateUser(putUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostResendInvitationRequest} postResendInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation(postResendInvitationRequest: PostResendInvitationRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.resendInvitation(postResendInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostResetPasswordRequest} postResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(postResetPasswordRequest: PostResetPasswordRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.resetPassword(postResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for forgotPassword operation in UsersApi.
 * @export
 * @interface UsersApiForgotPasswordRequest
 */
export interface UsersApiForgotPasswordRequest {
    /**
     * 
     * @type {PostForgotPasswordRequest}
     * @memberof UsersApiForgotPassword
     */
    readonly postForgotPasswordRequest: PostForgotPasswordRequest
}

/**
 * Request parameters for getCheckUser operation in UsersApi.
 * @export
 * @interface UsersApiGetCheckUserRequest
 */
export interface UsersApiGetCheckUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiGetCheckUser
     */
    readonly email: string
}

/**
 * Request parameters for getUsers operation in UsersApi.
 * @export
 * @interface UsersApiGetUsersRequest
 */
export interface UsersApiGetUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUsers
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUsers
     */
    readonly orderDesc?: string

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetUsers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetUsers
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUsers
     */
    readonly searchText?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUsers
     */
    readonly organization?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUsers
     */
    readonly group?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUsers
     */
    readonly status?: string
}

/**
 * Request parameters for postDoInvite operation in UsersApi.
 * @export
 * @interface UsersApiPostDoInviteRequest
 */
export interface UsersApiPostDoInviteRequest {
    /**
     * 
     * @type {PostUserInviteRequest}
     * @memberof UsersApiPostDoInvite
     */
    readonly postUserInviteRequest: PostUserInviteRequest
}

/**
 * Request parameters for postDoInviteV2 operation in UsersApi.
 * @export
 * @interface UsersApiPostDoInviteV2Request
 */
export interface UsersApiPostDoInviteV2Request {
    /**
     * 
     * @type {PostUserInviteRequest}
     * @memberof UsersApiPostDoInviteV2
     */
    readonly postUserInviteRequest: PostUserInviteRequest
}

/**
 * Request parameters for postDoSyncUser operation in UsersApi.
 * @export
 * @interface UsersApiPostDoSyncUserRequest
 */
export interface UsersApiPostDoSyncUserRequest {
    /**
     * 
     * @type {SpUser}
     * @memberof UsersApiPostDoSyncUser
     */
    readonly spUser: SpUser
}

/**
 * Request parameters for putDoSyncUser operation in UsersApi.
 * @export
 * @interface UsersApiPutDoSyncUserRequest
 */
export interface UsersApiPutDoSyncUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiPutDoSyncUser
     */
    readonly id: string

    /**
     * 
     * @type {PutSpUser}
     * @memberof UsersApiPutDoSyncUser
     */
    readonly putSpUser: PutSpUser
}

/**
 * Request parameters for putDoUpdateUser operation in UsersApi.
 * @export
 * @interface UsersApiPutDoUpdateUserRequest
 */
export interface UsersApiPutDoUpdateUserRequest {
    /**
     * 
     * @type {PutUserRequest}
     * @memberof UsersApiPutDoUpdateUser
     */
    readonly putUserRequest: PutUserRequest
}

/**
 * Request parameters for resendInvitation operation in UsersApi.
 * @export
 * @interface UsersApiResendInvitationRequest
 */
export interface UsersApiResendInvitationRequest {
    /**
     * 
     * @type {PostResendInvitationRequest}
     * @memberof UsersApiResendInvitation
     */
    readonly postResendInvitationRequest: PostResendInvitationRequest
}

/**
 * Request parameters for resetPassword operation in UsersApi.
 * @export
 * @interface UsersApiResetPasswordRequest
 */
export interface UsersApiResetPasswordRequest {
    /**
     * 
     * @type {PostResetPasswordRequest}
     * @memberof UsersApiResetPassword
     */
    readonly postResetPasswordRequest: PostResetPasswordRequest
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {UsersApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public forgotPassword(requestParameters: UsersApiForgotPasswordRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).forgotPassword(requestParameters.postForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetCheckUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCheckUser(requestParameters: UsersApiGetCheckUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCheckUser(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUser(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsers(requestParameters: UsersApiGetUsersRequest = {}, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsers(requestParameters.orderBy, requestParameters.orderDesc, requestParameters.page, requestParameters.limit, requestParameters.searchText, requestParameters.organization, requestParameters.group, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiPostDoInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public postDoInvite(requestParameters: UsersApiPostDoInviteRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).postDoInvite(requestParameters.postUserInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiPostDoInviteV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public postDoInviteV2(requestParameters: UsersApiPostDoInviteV2Request, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).postDoInviteV2(requestParameters.postUserInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiPostDoSyncUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public postDoSyncUser(requestParameters: UsersApiPostDoSyncUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).postDoSyncUser(requestParameters.spUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiPutDoSyncUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public putDoSyncUser(requestParameters: UsersApiPutDoSyncUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).putDoSyncUser(requestParameters.id, requestParameters.putSpUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiPutDoUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public putDoUpdateUser(requestParameters: UsersApiPutDoUpdateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).putDoUpdateUser(requestParameters.putUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiResendInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resendInvitation(requestParameters: UsersApiResendInvitationRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resendInvitation(requestParameters.postResendInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetPassword(requestParameters: UsersApiResetPasswordRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetPassword(requestParameters.postResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
